export default __webpack_public_path__ + "static/1-d2e1e65e2b58b5f8235ebe7d05245a46.jpeg";